import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManagementSection } from '../../ManagementSection';
import { PromotionButtonsSection } from '../../PromotionButtonsGroupSection';
import { PaidService } from '../../../../../graphql/types';
import { AuthorManagementBlockWrapper, ExpiresAtInfo } from './styled';
import useScreenSize from '../../../../../hooks/useScreenSize';

interface AuthorManagementBlock {
  isAuthor: boolean;
  isPublished: boolean;
  itemPath: string;
  isEditAvailable: boolean;
  isRemoveAvailable: boolean;
  isLimited: boolean;
  isRejected: boolean;
  paidServices: PaidService[];
  expiresAt?: string;
}

export const AuthorManagementBlock: React.FC<AuthorManagementBlock> = ({
  isAuthor,
  isPublished,
  itemPath,
  isEditAvailable,
  isRemoveAvailable,
  isLimited,
  isRejected,
  paidServices,
  expiresAt
}) => {
  const { t } = useTranslation();
  const { isLarge, isSmallDesktop } = useScreenSize();

  const isSmallOrLargeDesktop = isSmallDesktop || isLarge;

  return (
    <>
      {expiresAt && isPublished && isSmallOrLargeDesktop && (
        <ExpiresAtInfo tag="body_1" data-cy="info-expires-at">
          {`${t('pages.current_item.bottom_info.expiresAt')}: ${expiresAt}`}
        </ExpiresAtInfo>
      )}

      <AuthorManagementBlockWrapper>
        {expiresAt && isPublished && !isSmallOrLargeDesktop && (
          <ExpiresAtInfo tag="body_1">
            {`${t('pages.current_item.bottom_info.expiresAt')}: ${expiresAt}`}
          </ExpiresAtInfo>
        )}

        <ManagementSection
          {...{ itemPath, isEditAvailable, isRemoveAvailable, isPublished }}
        />

        {!isLimited && !isRejected && (
          <PromotionButtonsSection
            isAuthor={isAuthor}
            paidServices={paidServices}
          />
        )}
      </AuthorManagementBlockWrapper>
    </>
  );
};
